<template>
  <div class="simple-pagination">
    <button
      :disabled="pageIndex <= 1"
      @click="changePage(pageIndex - 1)"
      class="pagination-btn"
    >
      Previous
    </button>

    <div class="pagination-info">
      <span>Page {{ pageIndex }} of {{ totalPages }}</span>
    </div>

    <button
      :disabled="pageIndex >= totalPages"
      @click="changePage(pageIndex + 1)"
      class="pagination-btn"
    >
      Next
    </button>

    <select v-model.number="localPageSize" @change="onPageSizeChange" class="pagination-select">
      <option value="10">10 per page</option>
      <option value="25">25 per page</option>
      <option value="50">50 per page</option>
      <option value="100">100 per page</option>
    </select>

    <span class="pagination-total">
      Total: {{ total }} items
    </span>
  </div>
</template>

<script>
export default {
  name: 'SimplePagination',
  props: {
    total: {
      type: Number,
      required: true
    },
    pageIndex: {
      type: Number,
      required: true,
      default: 1
    },
    pageSize: {
      type: Number,
      required: true,
      default: 10
    }
  },
  emits: ['on-page-number-change', 'on-page-size-change'],
  data() {
    return {
      localPageSize: this.pageSize
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.total / this.localPageSize) || 1;
    }
  },
  watch: {
    pageSize(newVal) {
      this.localPageSize = newVal;
    }
  },
  methods: {
    changePage(newPage) {
      if (newPage >= 1 && newPage <= this.totalPages) {
        this.$emit('on-page-number-change', newPage);
      }
    },
    onPageSizeChange() {
      this.$emit('on-page-size-change', this.localPageSize);
    }
  }
};
</script>

<style>
.simple-pagination {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 15px;
  background-color: #f5f5f5;
  border-radius: 4px;
  flex-wrap: wrap;
  justify-content: center;
}

.pagination-btn {
  padding: 8px 12px;
  background-color: #3370d1;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s;
}

.pagination-btn:hover:not(:disabled) {
  background-color: #2556a0;
}

.pagination-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.pagination-info {
  padding: 8px 12px;
  background-color: white;
  border-radius: 4px;
  border: 1px solid #ddd;
  min-width: 120px;
  text-align: center;
  font-size: 14px;
}

.pagination-select {
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: white;
  cursor: pointer;
  font-size: 14px;
}

.pagination-total {
  font-size: 14px;
  color: #666;
  white-space: nowrap;
}
</style>

